export const eventRoles = ["PARTICIPANTE", "PALESTRANTE", "IMPRENSA"];
